import {
  POST_UPLOAD_COVID_VACCINE_CERTIFICATE_SUCCESS,
  POST_UPLOAD_COVID_VACCINE_CERTIFICATE_FAILURE,
} from "../constants/MyM";

const initStat = { data: [], error: false, errorData: "", isLoading: true };

export default (state = initStat, action) => {
  switch (action.type) {
    case POST_UPLOAD_COVID_VACCINE_CERTIFICATE_SUCCESS:
      return {
        ...state,
        data: action.payload,
        isLoading: false,
      };
    case POST_UPLOAD_COVID_VACCINE_CERTIFICATE_FAILURE:
      return {
        ...state,
        isLoading: false,
        errorData: action.payload,
        error: true,
      };
    default:
      return { ...state };
  }
};
